import { FC } from "react";
import { Button } from "ui-kit/Button";
import { SelectablePaymentMethodEnum } from "config/site";
import { useWebTranslation } from "translations";
import Icon from "ui-kit/Icon";
import Colors from "ui-kit/colors";
import { logEvent } from "analytics";

type PaymentButtonProps = {
  loading?: boolean;
  disabled?: boolean;
  onPaymentClick: () => Promise<void>;
  paymentMethod: SelectablePaymentMethodEnum;
  className?: string;
};

const PaymentButton: FC<PaymentButtonProps> = ({
  loading,
  disabled,
  onPaymentClick,
  paymentMethod,
  className,
}) => {
  const { t } = useWebTranslation();
  const completePurchaseTitle = t("payment.complete");
  const setupPaymentMethodTitle = t("payment.setup_payment_method");

  return (
    <Button
      loading={loading}
      disabled={disabled}
      onPress={() => {
        logEvent("COMPLETE_PAYMENT");
        return onPaymentClick();
      }}
      variant="custom"
      color="orange300"
      icon={
        <Icon
          name="lock"
          size={17}
          color={disabled ? Colors.grey300 : Colors.white}
        />
      }
      iconFirst
      title={
        paymentMethod === SelectablePaymentMethodEnum.Trustly ||
        paymentMethod === SelectablePaymentMethodEnum.TrustlyMdd
          ? setupPaymentMethodTitle
          : completePurchaseTitle
      }
      style={{
        position: "sticky",
        bottom: 16,
      }}
      className={className}
    />
  );
};

export default PaymentButton;
